(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7744],{

/***/ 84069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_landing_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94964);
/* harmony import */ var _components_landing_Head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81519);
/* harmony import */ var _components_landing_Press__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71723);
/* harmony import */ var _data_press_items_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48379);
/* harmony import */ var _data_seo_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35546);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);








var PRESS_DATA = _data_press_items_json__WEBPACK_IMPORTED_MODULE_4__.find(function (i) {
  return i.name === "datamynt-solana";
});

function DataMyntSolana() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_landing_Head__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      SEO: _data_seo_json__WEBPACK_IMPORTED_MODULE_5__
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_landing_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_components_landing_Press__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        item: PRESS_DATA,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "font-semibold text-lg",
          children: "Data Mynt\u2019s integration of the Solana Blockchain (SOL) will allow millions of SOL holders to use Solana for cryptocurrency payments around the world at any Data Mynt merchant location."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "San Francisco, CA (September 2, 2022) - Data Mynt, the leading provider of digital asset checkout and payments infrastructure for merchants and platforms around the world, announced the integration of the Solana blockchain. This enables any Solana wallet and owner to pay with SOL at any participating Data Mynt merchant globally, even if the merchant has never heard of Solana before."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt\u2019s omnichannel checkout and payment solutions provide a way for merchants to receive digital asset payments in several different tokens on the most widely used chains, with the merchant automatically receiving local stablecoin at the moment of the purchase deposited into the merchant\u2019s Data Mynt wallet. This allows shoppers to pay with one token, and merchants to receive another. In this way, shoppers and merchants alike who use Data Mynt can avoid headaches due to price volatility associated with token conversions."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "The Solana blockchain is one of the fastest growing cryptocurrency ecosystems in existence, with millions of users worldwide and a growing suite of associated applications and products. Capable of up to 2,500 transactions per second, and with an average cost of $0.00025 per transaction, the Solana ecosystem has already seen 94 billion transactions spread across over 2 million wallets. With a market cap of over $10 billion, the Solana blockchain is in the top 10 most popular blockchains and digital assets in the world."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "By adding support for SOL to Data Mynt, any Solana holder can use their stack of SOL to purchase goods and services at participating merchants. This unlocks a way for merchants to accept payment from the enthusiastic and friendly Solana community, a massive boon for both parties. Additionally, because Data Mynt allows for fast settlements and cash payouts in local currencies, there is now a pipeline for funds to flow from Solana holders to the bank accounts of small businesses around the world."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "With participating merchants across 15 countries and 5 continents, this is an important moment for Data Mynt and Solana alike. According to the CEO of Data Mynt, Alex Christian,"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "flex items-center space-x-8",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("svg", {
              width: "93",
              height: "68",
              viewBox: "0 0 93 68",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("g", {
                opacity: "0.3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M35.4316 0L39.7465 8.855C28.3005 13.363 24.6063 22.9233 24.19 27.14C32.29 28.6733 46.923 36.041 40.655 53.245C34.3869 70.449 17.9824 68.0033 10.5637 64.63C5.3782 62.3683 -3.67566 52.624 1.59314 31.74C6.86194 10.856 26.3474 1.87833 35.4316 0Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("path", {
                  d: "M86.2577 0L90.5727 8.855C79.1267 13.363 75.4325 22.9233 75.0161 27.14C83.1161 28.6733 97.7492 36.041 91.4811 53.245C85.2131 70.449 68.8086 68.0033 61.3899 64.63C56.2044 62.3683 47.1505 52.624 52.4193 31.74C57.6881 10.856 77.1736 1.87833 86.2577 0Z",
                  fill: "#3D8ECD"
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-gray-50",
            children: "\u201CWe wanted to add support for a cryptocurrency that was exciting, had a reputable team and roadmap execution, and was known for its enthusiastic community that loves to use cryptocurrency. Solana was an instant favorite among our team, and we can\u2019t wait to see how their users find ways to pay with SOL at a Data Mynt merchant nearest them.\u201D"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("p", {
          className: "text-gray-50",
          children: ["Interested merchants and businesses can add Data Mynt digital asset checkout now at", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "https://play.google.com/store/apps/details?id=com.datamynt",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "text-primary underline",
              children: "Google Play Store"
            })
          }), " ", "and", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
            href: "https://apps.apple.com/us/app/datamynt-point-of-sale-pos/id1572840222",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              className: "text-primary underline",
              children: "App Store"
            })
          }), "."]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h6", {
          className: "text-black text-md",
          children: "About DataMynt"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt is the leading digital asset payment and checkout solution for omnichannel sellers everywhere. Its suite of solutions offers platforms and merchants an easy approach to accepting and sending digital payments from any blockchain, wallet or asset, free from volatility and the usual risks and costs of traditional payment methods such as cards. The Data Mynt digital asset checkout payment solution is designed to streamline implementation via a mobile Point of Sale, API, branded web page, and iFrame, while consistently delivering a seamless customer experience. Learn more:"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("ul", {
          className: "flex space-x-4",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://datamynt.com",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Website"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://twitter.com/DataMynt",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Twitter"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            children: "|"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://www.linkedin.com/company/datamynt/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "LinkedIn"
              })
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h6", {
          className: "text-black text-md",
          children: "About Solana"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-gray-50",
          children: "Solana (SOL) is one of the most popular and fastest growing cryptocurrency ecosystems in the world. With a genesis block occurring in March of 2020, Solana has seen massive growth in less than three years. Known for its fast transaction times, low transaction costs, and scalable blockchain solutions, the Solana blockchain has been one of the most well-known cryptocurrency ecosystems in the past few years."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
          className: "flex space-x-4",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
              target: "_blank",
              href: "https://solana.com/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
                className: "text-primary font-semibold",
                children: "Website"
              })
            })
          })
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (DataMyntSolana);

/***/ }),

/***/ 21346:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/datamynt-solana",
      function () {
        return __webpack_require__(84069);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,7258,5675,2580,6770,646,9530,2834,7965,4964,169,6111,9774,2888,179], function() { return __webpack_exec__(21346); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);